import React from "react";

import 'bootstrap/dist/css/bootstrap.css';
import Navbar from "./navbar";
import './css_files/about.css';
import Footer from "./footer";
import { styled } from "@stitches/react";
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination } from "swiper";

const About = () => {
    return (
        <Root className="">
            <Navbar />

            <div>

                <Swiper className="w-100 h-100"
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                    }}

                    pagination={true}
                    modules={[Autoplay, Pagination]}
                >
                    <div className="who">
                        Who are we?
                    </div>
                    <SwiperSlide>
                        <Imagediv src={'https://res.cloudinary.com/daurieb51/image/upload/v1682964208/post2_rnlxid.jpg'} alt="About image" className=" responsive w-100 img-fluid" style={{
                            objectPosition: "top"
                        }} />
                    </SwiperSlide>
                    <SwiperSlide>
                        <Imagediv src={'https://res.cloudinary.com/daurieb51/image/upload/v1682966141/gpld7docllrlmxpcb68r.jpg'} alt="About image" className=" responsive w-100 img-fluid" style={{
                            objectPosition: "bottom"
                        }} />
                    </SwiperSlide>

                    <SwiperSlide>
                        <Imagediv src={'https://res.cloudinary.com/daurieb51/image/upload/v1682722993/wvrdfbzetfw9gfpirpp9.jpg'} alt="About image" className=" responsive w-100 img-fluid" style={{
                            objectPosition: "bottom"
                        }} />
                    </SwiperSlide>

                </Swiper>

            </div>
            <div className="px-4 lg:px-5 py-2 text-left">



                <div className="content-div mt-5 pt-5">

                    <div className="row align-items-center justify-content-center">
                        <div className='col-lg-5 bg-white '>

                            <p className="about-title">Who are we?</p>


                            <p>This registry is an international registry which enables breeders in Africa and overseas who breed American bullies,
                                American bull dogs, American Pitbull Terriers, French bull dogs and all other "bully" breeds to come under one umbrella.</p>
                            <p>We are primarily located in Accra, Ghana. However, our expansion is steadily pushing us to new countries and places.</p>
                            <p>We are made up of a diverse team of committed individuals who are knee deep in the profession of rearing and raising bull breeds</p>




                        </div>
                        <div className="col-lg-5">
                            <img src="/images/about2.png" className="img-fluid w-100" />
                        </div>

                    </div>
                    <div className="row align-items-center justify-content-center reverse-sm">

                        <div className='col-lg-5 bg-white '>

                            <p className="about-title">What is our purpose?</p>

                            <p>This registry is created to bring and unite all passionate breeders and dog lovers together, especially in Africa..</p>

                            <p> For many years breeders in Africa had to rely on other registry's outside the continent to register their dogs.</p>
                            <p>This comes with a lot of challenges.</p>
                            <p> To be able to achieve our goal of uniting and bringing the continent together, the African BULLY REGISTRY intends to put together series of shows
                                both conformation and assessment tests for pure breeds without documents and other breed worthy events in various countries across Africa‼️</p>


                        </div>

                        <div className="col-lg-5">
                            <img src="/images/about3.png" className="img-fluid w-100 " />
                        </div>
                    </div>
                    <div className="row align-items-center justify-content-center">
                        <div className='col-lg-5 bg-white '>


                            <p className="about-title">What's in store for you?</p>

                            <p>Besides exciting shows, events, dog competittions
                                and being part of our warm continue, we provide you with a platform to showcase your hardwork to the world. Publish exciting
                                posts on our platform.
                            </p>
                            <p>Registered members can also create advertissements to attract people who may want to buy or mate with their beloved dogs. We hope to help make the bully community a more exciting place to be </p>

                            <p>Feel free to contact us should you like to discuss any thing on your mind!!!</p>

                            <p>AFBR</p>


                        </div>
                        <div className="col-lg-5">
                            <img src="/images/abou4.png" className="img-fluid w-100" />
                        </div>

                    </div>

                </div>
            </div>



            <Footer />


        </Root>



    )
}

export default About;
const Root = styled('div', {
    ".about-title": {
        fontSize: "2rem",
        fontWeight: "600",
        borderBottom: "3px solid #ba8108",
        marginBottom: "2rem",
    },
    ".row": {
        lineHeight: "2"
    },

    ".who": {
        background: "rgba(37, 27, 3, 0.31)",
        fontSize: "40px",
        fontWeight: "bold",
        paddingBlock: "1rem",
        position: "absolute",
        top: "0px",
        zIndex: "100",
        width: "100%",
        color: "white",
        textAlign: "left",
        paddingInline: "2rem"
    },
    ".what-is": {
        fontSize: "48px",
    },
    ".content-div": {
        display: "flex",
        flexDirection: "column",
        gap: "10rem",
        "@media screen and (min-width:768px) and (max-width:1024px)": {
            gap: "3rem"
        },
        "@media screen and (max-width:768px)": {
            gap: "3rem"
        }
    },
    ".reverse-sm": {
        flexDirection: "row-reverse",
        "@media screen and (max-width:768px)": {
            flexDirection: "row"
        }
    },
    ".img-fluid": {
        aspectRatio: "1/1",
        objectFit: "cover",
        // "@media screen and (min-width:768px) and (max-width:1024px)":{
        //     maxHeight:"400px",
        //     objectFit:"cover"
        // }
    },
    ".swiper": {
        position: "relative"
    }
})

const Imagediv = styled('img', {
    height: '100vh',
    width: "100%",
    objectFit: "cover",
    "@media screen and (max-width:768px)":{
        height:"80vh"
    }
})